<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/renewal/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <div>
          <el-row :gutter="20" style="padding-bottom: 8px;">
            <el-col :span="6">
              <div>{{ $t('kehubianma') }}: {{ customerInfo.code }}</div>
            </el-col>
            <el-col :span="6">
              <div>{{ $t('kehumingcheng') }}: {{ customerInfo.name }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div>{{ $t('chuangjianshijian') }}: {{ dayjs(customerInfo.createTime).format('YYYY-MM-DD') }}</div>
            </el-col>
            <el-col :span="6">
              <div>{{ $t('shixiaoshijian') }}: {{ customerInfo.endTime && dayjs(customerInfo.endTime).format('YYYY-MM-DD') }}</div>
            </el-col>
            <el-col :span="6">
              <div>{{ $t('shengyutianshu') }}: {{ leftDays() }}</div>
            </el-col>
          </el-row>
          <br />
        </div>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" type="primary" plain="plain" @click="yt.get(1)">
          {{ $t('sousuo') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>

      <template #xuqikaishishijian="scope">
        <span>{{ dayjs(scope.row.beginTime).format('YYYY-MM-DD') }}</span>
      </template>
      <template #xuqijieshushijian="scope">
        <span>{{ dayjs(scope.row.endTime).format('YYYY-MM-DD') }}</span>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/customer/renewal/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xuqikaishishijian')" required>
            <el-date-picker v-model="yt.editObj.beginTime" type="date" :placeholder="$t('qingxuanze')" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqijieshushijian')" required>
            <el-date-picker v-model="yt.editObj.endTime" type="date" :placeholder="$t('qingxuanze')" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqiren')">
            <el-input v-model="yt.editObj.person" :maxlength="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark" type="textarea" :rows="2" :maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/customer/renewal/create')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xuqikaishishijian')" required>
            <el-date-picker v-model="yt.editObj.beginTime" type="date" :placeholder="$t('qingxuanze')" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqijieshushijian')" required>
            <el-date-picker v-model="yt.editObj.endTime" type="date" :placeholder="$t('qingxuanze')" value-format="timestamp"> </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xuqiren')">
            <el-input v-model="yt.editObj.person" :maxlength="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark" type="textarea" :rows="2" :maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/customer/renewal/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';

export default {
  name: 'admin_customer_info_renewal_list',
  props: {
    customerInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'xuqikaishishijian',
          prop: 'beginTime',
          type: 'slot',
          width: 150
        },
        {
          label: 'xuqijieshushijian',
          prop: 'endTime',
          type: 'slot',
          width: 150
        },
        {
          label: 'bencixuqitianshu',
          prop: 'day'
        },
        {
          label: 'xuqiren',
          prop: 'person'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuoshijian',
          prop: 'updateTime',
          type: 'time',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      const conditions = {
        customerId: this.customerInfo.id
      }
      this.yt.conditions = conditions;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 剩余天数
    leftDays() {

      const endTime = this.customerInfo.endTime;
      if (endTime) {
        const startTime = new Date().getTime();
        const leftDays = (endTime/1000/3600/24).toFixed(0) - (startTime/1000/3600/24).toFixed(0) ;
        return leftDays >= 0 ? leftDays : '';
      }
      return '';
    },
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      row.customerId = this.customerInfo.id;
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      return row;
    }
  }
};
</script>
